import { render, staticRenderFns } from "./DashboardPage.component.pug?vue&type=template&id=0a1c4f60&scoped=true&lang=pug&"
import script from "./DashboardPage.component.ts?vue&type=script&lang=ts&"
export * from "./DashboardPage.component.ts?vue&type=script&lang=ts&"
import style0 from "./DashboardPage.component.scss?vue&type=style&index=0&id=0a1c4f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1c4f60",
  null
  
)

export default component.exports